// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","image":"GvyoP","legend":"_22Hi6","title":"_10wDi","subtitle":"_3MStH","cta":"_2mO4O"};